import React, { useState, useEffect } from "react";
import { transitions, positions, Provider as AlertProvider } from 'react-alert'
import CustomAlertTemplate from "../utility_components/CustomAlertTemplate";

import { FeatureFlagsProvider } from "./contexts/FeatureFlags";
import ResearcherApp from './ResearcherApp';

function ResearcherAppWrapper(props) {


    // optional configuration
    const alertOptions = {
        // you can also just use 'bottom center'
        position: positions.BOTTOM_CENTER,
        timeout: 5000,
        offset: '30px',
        // you can also just use 'scale'
        transition: transitions.SCALE
    }

    return (
        <div className="researcher-app">
            <AlertProvider template={CustomAlertTemplate} {...alertOptions}>
                <FeatureFlagsProvider>
                    <ResearcherApp />
                </FeatureFlagsProvider>
            </AlertProvider>
        </div>
    )
}

export default ResearcherAppWrapper;